;(function ($) {
	let loaderGif = $("#loader-gif");
	let globalLang = $('html').attr('lang');
	$(document).ready(function () {
		
		$('#placeOrder').bind("keypress", function(e) {
			if (e.keyCode == 13) {
				e.preventDefault();
				return false;
			}
		});
		
		$(document).on('change', '.add-to-cart-form select, .add-to-cart-form input:radio', function () {
			let form = $(this).parents('form.add-to-cart-form');
			let serializedForm = form.serializeArray();
			let priceBlock = '';
			let productStockBlock = '';
			let productCountBlock = '';
			
//			let submitBtn = form.find('.product__button');
			
			$.ajax({
				method: "POST",
				url: `${window.location.origin}/${globalLang}/validateAddToCart`,
				beforeSend: function () {
					
//					submitBtn.addClass('loading');
				},
				data: serializedForm,
				success: function (response) {
					
					if (response.variationsDetails) {
						$('.stock-block').removeClass('product__stock-no');
						$('.stock-block').removeClass('product__stock');
						
						if (response.variationsDetails.stock ){
							$('.stock-block').addClass('product__stock')
							$('.stock-block').html(response.variationsDetails.stock_text);
						} else {
							$('.stock-block').html(response.variationsDetails.stock_text);
							
							$('.stock-block').addClass('product__stock');
							$('.stock-block').addClass('product__stock-no')
						}
					} else {
						$('.stock-block').html(response.stock_text);
						$('.stock-block').addClass('product__stock');
						$('.stock-block').addClass('product__stock-no')
					}
					
//					submitBtn.removeClass('loading');
					form.find('.submit-add-to-cart-btn').addClass('disabled').prop('disabled', true);
					
					if (response.status && response.variationsDetails) {
						
						if (response.variationsDetails.price)
							
							priceBlock += `<div class=" product__price price ${response.variationsDetails.sale_price ? 'cardSale' : ''}">${response.variationsDetails.price} ${response.variationsDetails.price_unit}</div>`;
						
						if (response.variationsDetails.sale_price)
							priceBlock += `<div class="product__price sale-price">${response.variationsDetails.sale_price} ${response.variationsDetails.price_unit}</div>`;
						
						
						if (response.variationsDetails.stock) {
							if (isNumeric(response.variationsDetails.stock))
								productStockBlock += `<span class="stock">${response.variationsDetails.stock} in stock</span>`;
							
							productCountBlock +=`<div class="product__number">`;
							productCountBlock +=`<span class="product__text">Cantitate</span>`;
							productCountBlock += `<div class="item__count__wrap count-items-block">`;
							productCountBlock += `<input type="text" class="item__count update-product-quantity" id="count-items" data-id="${response.variationsDetails.id}" name="count-items" value="1" ${isNumeric(response.variationsDetails.stock) ? `data-max-value=${response.variationsDetails.stock}` : ''}>`;



							 	productCountBlock += `<div class="arrow-up plus update-product-quantity product__add" data-op="sum" data-id="${response.variationsDetails.id}">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 4.207">
                                            <defs>
                                                <style>
                                                    .cls-1 {
                                                        fill: none;
                                                        stroke: #c4cdd5;
                                                        stroke-linecap: round;
                                                        stroke-miterlimit: 10;
                                                    }
                                                </style>
                                            </defs>
                                            <path id="next" class="cls-1" d="M0,0,3,3,0,6" transform="translate(6.5 0.5) rotate(90)"/>
                                        </svg>

                                    </div>`;
								productCountBlock += `  <div class="arrow-down minus update-product-quantity product__erase" data-op="diff" data-id="${response.variationsDetails.id}">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 4.207">
                                            <defs>
                                                <style>
                                                    .cls-1 {
                                                        fill: none;
                                                        stroke: #c4cdd5;
                                                        stroke-linecap: round;
                                                        stroke-miterlimit: 10;
                                                    }
                                                </style>
                                            </defs>
                                            <path id="next" class="cls-1" d="M0,0,3,3,0,6" transform="translate(6.5 0.5) rotate(90)"/>
                                        </svg>

                                    </div>`;
							 productCountBlock += `</div>`;
							productCountBlock += `</div>`;

							
							if (response.variationsDetails.price)
								form.find('.submit-add-to-cart-btn').removeClass('disabled').prop('disabled', false);
						}
						else
							productStockBlock += `<span class="stock out-of-stock">${$('.product-stock-block').data('out-of-stock-msg')}</span>`;
					}
					
					form.find('.variation-price-block').html(priceBlock);
					form.find('.product-stock-block').html(productStockBlock);
					form.find('.product-count-block').html(productCountBlock);
					
				},
				error: function () {
//					submitBtn.addClass('error');
					
//					setTimeout(function () {
////						submitBtn.removeClass('error');
//					}, 1000);
				}
			});
			
		});
		
		$(document).on("keyup click", ".update-product-quantity", function (evt) {
			
			var _this = $(this);
			var operation = _this.data('op');
			var isInput = $(evt.target).get(0).nodeName === 'INPUT';
			
			if (isInput) {
				
				var e = evt || window.event;
				var key = e.which || e.keyCode;
				var validKeys = (
					key >= 48 && key <= 57 // numbers
					|| key >= 96 && key <= 105 // num pad
					|| key === 8 // backspace
					|| key === 46 // delete
				);
				
				if (!validKeys)
					_this.val(!isNaN(parseInt(_this.val())) ? parseInt(_this.val()) : 1);
				
				if ((parseInt(_this.val()) < 1 || isNaN(parseInt(_this.val()))))
					_this.val(1);
				else
					_this.val(parseInt(_this.val()));
				
				var quantity = parseInt(_this.val());
			}
			else if (operation !== undefined) {
				var inputVal = parseInt(_this.siblings('input').val());
				
				if (operation === 'diff')
					_this.siblings('input').val(inputVal - 1 > 0 ? inputVal - 1 : 1);
				else if (operation === 'sum')
					_this.siblings('input').val(inputVal + 1);
				
				quantity = parseInt(_this.siblings('input').val());
			}
			
			if (isInput) {
				if (_this.data('max-value') !== undefined && _this.data('max-value') !== '' && _this.data('max-value') < quantity)
					_this.val(_this.data('max-value'));
			}
			else {
				if (_this.siblings('input').data('max-value') !== undefined && _this.siblings('input').data('max-value') !== '' && _this.siblings('input').data('max-value') < quantity)
					if (_this.siblings('input').data('max-value') !== undefined && _this.siblings('input').data('max-value') !== '' && _this.siblings('input').data('max-value') < quantity)
						_this.siblings('input').val(_this.siblings('input').data('max-value'));
			}
			
			if (_this.hasClass('update-cart') && ((evt.type === 'keyup' && isInput) || (evt.type === 'click' && !isInput)))
				$.ajax({
						method: "POST",
						url: `${window.location.origin}/${globalLang}/updateCart`,
						data: {
							id: _this.data('id'),
							quantity: quantity
						}
					})
					.success(function (response) {
						
						if (response.status) {
							
							$('#cart-count').text(response.count);
							$('.cart-count-products').find('span').text(response.count);
							$(_this).parents('.item').find('.total-items').html(response.productSubtotal);
							$('.current-price').text(response.total + ' '+ response.valute);
							$('.cart-count').text(response.count);
							
							$('.current-price').attr('data-price',response.total);
							
							
							var option_price = 0;
							
							var list_option = $('.option-list input:checked');
							$.each(list_option, function (obj,option) {
								if ($(option).attr('data-price') !== ''){
									option_price += parseInt($(option).attr('data-price'));
								}
							});
							
							var current_price  = $('.current-price').attr('data-price');
							
							$('.price-final').html(parseInt(option_price)+parseInt(current_price));
							
							//$('.cart-count-products').find('span').text(response.count);
							
//							$('.cart-subtotal-price-products').find('span').text(response.productSubtotal);
							$('.total-cart-amount').find('span.amount').text(response.total);
							
							//    Cart header thumbnail
//							$(`.cartSlideToggle .product[data-item-id="${_this.data('id')}"]`).find('.countProduct span').text(response.productQty);
//							$('.header-cart-remain-products').find('span').text(`+${response.count - 3}`);
//							$('.header-cart-subtotal-products').find('span').text(response.productSubtotal);
							
							//    Cart header thumbnail
						}
					})
					.fail(function (response) {
					});
			
		});
		
		$('.add-to-cart-form button.submit-add-to-cart-btn').on('click', function (e) {
			e.preventDefault();
			
			let form = $(this).parents('form.add-to-cart-form');
			
			addToCartForm(form);
		});
	});
	function addToCartForm(form) {
		if (form.length < 1) {
			return;
		}
		let submitBtn = form.find('.product__button');
		form.submit(function (event) {
			event.preventDefault();
		});
		let serializedForm = $(form).find("select, input").serializeArray();
		item = $(form).find('.btn-add-to-cart');
		$.ajax({
			method: "POST",
			url: form.attr('action'),
			beforeSend: function () {
				submitBtn.addClass('loading');
			},
			data: serializedForm,
			success: function (response) {
				submitBtn.removeClass('loading');
				submitBtn.addClass('added');
			
				if (response.status) {
					$('.cart-count').html(response.count);
					$('.cart-count').removeClass('hidden')
					$(item).next('#item-cart-status').addClass('active');
					$(item).next('#item-cart-status').html('<i class="fa fa-check"></i>');
					setTimeout(function () {
						$(item).next('#item-cart-status').removeClass('active');
						$(item).next('#item-cart-status').html('');
					}, 1000);
				}else{
					submitBtn.addClass('error');
					
					setTimeout(function () {
						submitBtn.removeClass('error');
					}, 1000);
					
				}
				
				setTimeout(function () {
					submitBtn.removeClass('added');
				}, 1000);
			},
			error: function () {
				
				submitBtn.addClass('error');
				
				setTimeout(function () {
					submitBtn.removeClass('error');
				}, 1000);
			}
		});
	}
})
(jQuery);
function isNumeric(string) {
	return !isNaN(parseFloat(string)) && isFinite(string);
}